// .job-floating 表示/非表示 -----
document.addEventListener("DOMContentLoaded", () => {
	const pageHead = document.querySelector(".c-page-head");
	const jobFloating = document.querySelector(".job-floating");
	const footer = document.querySelector(".footer");

	if (!pageHead || !jobFloating || !footer) return;

	let isPageHeadPassed = false;
	let isFooterVisible = false;

	const updateFloating = () => {
		const shouldShow = isPageHeadPassed && !isFooterVisible;

		jobFloating.classList.toggle("is-show", shouldShow);
		jobFloating.setAttribute("aria-hidden", String(!shouldShow));
	};

	const pageHeadObserver = new IntersectionObserver(
		([entry]) => {
			isPageHeadPassed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;

			updateFloating();
		},
		{
			threshold: 0,
		},
	);

	const footerObserver = new IntersectionObserver(
		([entry]) => {
			isFooterVisible = entry.isIntersecting;
			updateFloating();
		},
		{
			threshold: 0,
		},
	);

	pageHeadObserver.observe(pageHead);
	footerObserver.observe(footer);
});
